module.exports = __webpack_public_path__ + "assets/img/landing-top_bg.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/landing-top_bg.png
// module id = 702
// module chunks = 0